module.exports = __webpack_public_path__ + "img/isthesame.8c27a8d5.png";